import { useState, useEffect } from "react";
import { X, DownloadSimple, DeviceMobile } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Check if already installed
    const standalone = window.matchMedia('(display-mode: standalone)').matches || 
                       window.navigator.standalone === true;
    setIsStandalone(standalone);

    // Check if iOS
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsIOS(ios);

    // Listen for install prompt
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show banner after a delay
      setTimeout(() => {
        if (!localStorage.getItem('pwa-install-dismissed')) {
          setShowInstallBanner(true);
        }
      }, 3000);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);

    // Check if should show iOS instructions
    if (ios && !standalone && !localStorage.getItem('pwa-install-dismissed')) {
      setTimeout(() => setShowInstallBanner(true), 3000);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('PWA installed');
    }
    
    setDeferredPrompt(null);
    setShowInstallBanner(false);
  };

  const handleDismiss = () => {
    setShowInstallBanner(false);
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  // Don't show if already installed or dismissed
  if (isStandalone || !showInstallBanner) return null;

  return (
    <div 
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-white border border-zinc-200 rounded-lg shadow-lg p-4 z-50 animate-fade-in"
      data-testid="install-pwa-banner"
    >
      <button 
        onClick={handleDismiss}
        className="absolute top-2 right-2 p-1 text-zinc-400 hover:text-zinc-600"
        data-testid="dismiss-install-btn"
      >
        <X size={20} />
      </button>

      <div className="flex items-start gap-3">
        <div className="p-2 bg-blue-100 rounded-lg">
          <DeviceMobile size={24} className="text-blue-700" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-zinc-900 dark:text-slate-100 text-sm">Installer MikAuto</h3>
          <p className="text-xs text-zinc-500 mt-1">
            {isIOS 
              ? "Appuyez sur le bouton Partager puis 'Sur l'écran d'accueil'"
              : "Installez l'application pour un accès rapide"}
          </p>
          
          {!isIOS && deferredPrompt && (
            <Button 
              onClick={handleInstall}
              size="sm"
              className="mt-3 bg-blue-700 hover:bg-blue-800 text-xs"
              data-testid="install-app-btn"
            >
              <DownloadSimple size={16} className="mr-1" />
              Installer
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
